import { RepairerOptionsForm } from "./Form";
import useRepairerOptions from "./hooks/useRepairerOptions";

export const RepairerOptions = () => {
  const props = useRepairerOptions();
  return <RepairerOptionsForm {...props} />;
};

export default RepairerOptions;
